import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';

import ENV from 'register-partners-js/config/environment';

const { backendUrlsTable, frontendUrlsTable } = getUrlsTable(ENV);

export const {
  apiBaseURL,
  authBaseURL,
  registerPartnersBaseURL: partnerBaseURL,
  registerBaseURL,
  websocketBaseURL,
  billerBaseURL,
  companyCreationBaseURL,
} = backendUrlsTable;

export const {
  registerJsURL,
  appJsURL: jsURL,
  embedOnboardingURL,
  companyCreationJsURL,
} = frontendUrlsTable;

// in Qonto APIs, namespaces are applied to resources
export const apiNamespace = 'v1';
export const authNamespace = 'v2';
export const authUserNamespace = 'v2';
export const organizationsNamespace = 'v3';
export const partnerNamespace = 'client_api';
